var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldTicketDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7A34066A-1F63-4B02-86B5-AB68BFE90BE0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Money-Bold",
    transform: "translate(-748.000000, -572.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ticket-discount",
    transform: "translate(748.000000, 572.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,10.1393757 L22,9.20937538 C22,5.10937548 20.7499995,3.859375 16.6499996,3.859375 L7.3499999,3.859375 C3.25,3.859375 2,5.10937548 2,9.20937538 L2,9.67937565 C2,10.0693756 2.31000006,10.3793755 2.70000005,10.3793755 C3.60000002,10.3793755 4.32999992,11.1093756 4.32999992,12.0093756 C4.32999992,12.9093755 3.60000002,13.6293755 2.70000005,13.6293755 C2.31000006,13.6293755 2,13.9393753 2,14.3293753 L2,14.7993755 C2,18.8993754 3.25,20.149374 7.3499999,20.149374 L16.6499996,20.149374 C20.7499995,20.149374 22,18.8993754 22,14.7993755 C22,14.4093755 21.6899992,14.0993757 21.2999992,14.0993757 C20.3999993,14.0993757 19.6700001,13.3693756 19.6700001,12.4693756 C19.6700001,11.5693756 20.3999993,10.8393755 21.2999992,10.8393755 C21.6899992,10.8393755 22,10.5293757 22,10.1393757 Z M10,9.87937546 C10,10.4293755 9.56,10.8793755 9,10.8793755 C8.44999999,10.8793755 8,10.4293755 8,9.87937546 C8,9.32937545 8.44,8.87937546 9,8.87937546 C9.55000001,8.87937546 10,9.32937545 10,9.87937546 Z M13.9899998,14.8793755 C13.9899998,14.3293754 14.4399998,13.8793755 14.9899998,13.8793755 C15.5399998,13.8793755 15.9899998,14.3293754 15.9899998,14.8793755 C15.9899998,15.4293755 15.56,15.8793755 15,15.8793755 C14.44,15.8793755 13.9899998,15.4293755 13.9899998,14.8793755 Z M9.17000008,16.2093744 C9.02000007,16.359375 8.83000034,16.4293756 8.64000034,16.4293756 C8.45000035,16.4293756 8.25999966,16.359375 8.10999966,16.2093744 C7.81999967,15.9193744 7.81999967,15.439375 8.10999966,15.149375 L14.8400002,8.41937542 C15.1300001,8.12937543 15.6099996,8.12937543 15.8999996,8.41937542 C16.1899996,8.70937541 16.1899996,9.18937489 15.8999996,9.47937489 L9.17000008,16.2093744 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldTicketDiscount);
export default __webpack_public_path__ + "static/media/vuesax-bold-ticket-discount.c124abbf89139404fe2fea4df80e478d.svg";
export { ForwardRef as ReactComponent };